import { phoneRules } from '@/components/Phone/const';
import { PICKER_STATUS } from '../components-biz/MapPicker';

export const DANGEROUS_CATE_IDS = [277, 48]; // 高危类目需要上传图文
export const NEW_SHOP_SUBMIT_SOURCE = 'mdc';
export const NEW_SHOP_SUBMIT_CLIENTTYPE = 1;
export const NEW_SHOP_SUBMIT_ENTRANCE = {
  newShop: 'normalAdd',
  newGroup: 'chainAdd',
};
export const NEW_SHOP_FROM_SOURCE = {
  newShop: 'newShop',
  newGroup: 'newGroup',
};
export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 3 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
    md: { span: 15 },
  },
};
export function fieldConfig() {
  function handleValidator(rule, value, callback, aiResultInfo) {
    const aiResult = aiResultInfo || {};
    const checkKey = rule.field;
    if (checkKey && aiResult.fieldMap && aiResult.fieldMap[checkKey]) {
      callback(aiResult.fieldMap[checkKey]);
    }
    callback();
  }

  const {
    shopName,
    branchName,
    provinceId,
    cityId,
    districtId,
    backCateList,
    frontCateName,
    supplyType,
    openStatus,
    phoneList,
  } = this.props.newShopInfo || {};
  const isNewGroup = this.props.newType === 'newGroup';
  const backCateIds = (backCateList || []).map(item => item.id);
  const backCateName = (backCateList || []).map(item => item.name).join(',');

  return {
    shopName: {
      initialValue: shopName,
      rules: [
        {
          required: true,
          message: '请输入门店名称',
        },
        {
          validator: (rule, value, callback) =>
            handleValidator(rule, value, callback, this.props.aiResult),
        },
      ],
    },
    branchName: {
      initialValue: branchName,
      rules: [
        {
          required: isNewGroup, //新增连锁是必填
          message: '请输入分店名称',
        },
        {
          validator: (rule, value, callback) =>
            handleValidator(rule, value, callback, this.props.aiResult),
        },
      ],
    },
    adCode: {
      initialValue: provinceId ? [provinceId, cityId, districtId] : null,
      rules: [
        {
          required: true,
          message: '请选择所在地区',
        },
        {
          validator: (rule, value, callback) =>
            handleValidator(rule, value, callback, this.props.aiResult),
        },
      ],
    },
    address: {
      rules: [
        {
          required: true,
          message: '请输入详细地址',
        },
        {
          validator: (rule, value, callback) =>
            handleValidator(rule, value, callback, this.props.aiResult),
        },
      ],
    },
    mapPickerStatus: {
      initialValue: {
        status: PICKER_STATUS.RECOMMEND,
        currentLocation: {},
      },
      getValueFromEvent: e => e,
      rules: [
        {
          validator: (rule, value, callback, source) => {
            if (
              source.nonLngLat === false &&
              [PICKER_STATUS.RECOMMEND, PICKER_STATUS.EDITING].includes(value.status)
            ) {
              callback('请确认门店在地图上的位置');
              return;
            }
            callback();
          },
        },
      ],
    },
    backCateName: {
      initialValue: backCateName,
    },
    backCateId: {
      initialValue: backCateIds,
      rules: [
        {
          required: true,
          message: '请选择后台品类',
        },
        {
          validator: (rule, value, callback) =>
            handleValidator(rule, value, callback, this.props.aiResult),
        },
      ],
    },
    frontCate: {
      initialValue: frontCateName,
    },
    supplyType: {
      initialValue: supplyType,
      rules: [
        {
          required: true,
          message: '请选择供给类型',
        },
        {
          validator: (r, v, c) => handleValidator(r, v, c, this.props.aiResult),
        },
      ],
    },
    openStatus: {
      initialValue: openStatus,
      rules: [
        {
          required: true,
          message: '请选择营业状态',
        },
        {
          validator: (rule, value, callback) =>
            handleValidator(rule, value, callback, this.props.aiResult),
        },
      ],
    },
    bizTime: {
      rules: [
        {
          validator: (rule, value, callback) =>
            handleValidator(rule, value, callback, this.props.aiResult),
        },
      ],
    },
    phoneList: {
      initialValue: phoneList,
      rules: phoneRules(),
    },
    nonLngLat: {
      initialValue: null,
      rules: [
        {
          required: true,
          message: '请确认是否知道门店位置',
        },
      ],
    },
  };
}

export const NEW_SHOP_LX_INFO = {
  pvCid: 'c_dianping_nova_prec46zl',
  shopNameMc: 'b_dianping_nova_akv2izqg_mc',
  branchNameMc: 'b_dianping_nova_udcqxfub_mc',
  adCodeMc: 'b_dianping_nova_hr91qn4d_mc',
  addressMc: 'b_dianping_nova_rn9q8djl_mc',
  locationMe: 'b_dianping_nova_k2b4da3r_me',
  backCateIdMc: 'b_dianping_nova_51n58y95_mc',
  openStatusMc: 'b_dianping_nova_voftkohj_mc',
  telTypeMobileMc: 'b_dianping_nova_3dzmg3sr_mc',
  telTypeLandMc: 'b_dianping_nova_jo3xaws3_mc',
  phoneMc: 'b_dianping_nova_28r17omg_mc',
  addPhoneMc: 'b_dianping_nova_jsr5pdjc_mc',
  bizTimeMc: 'b_dianping_nova_sgx2xd39_mc',
  imgAddMc: 'b_dianping_nova_lmqkq2xb_mc',
  imgDelMc: 'b_dianping_nova_v5kt76up_mc',
  commentMc: 'b_dianping_nova_ehcuofqv_mc',
  submitMc: 'b_dianping_nova_ysgu9ta8_mc',
  imgExampleMc: 'b_dianping_nova_u18jhjah_mc',
};

export const QUALIFICATIONS_GROUP = {
  brand: {
    addPoiType: 1,
    addPoiReason: '门店品牌变更',
    footerBtnText: '提交资质',
    formConfig: [
      {
        title: '1.新门店的招牌',
        subTitle: '',
        type: 1,
      },
      {
        title: '2.营业执照',
        subTitle: '',
        type: 2,
      },
      {
        title: '3.法人身份证',
        subTitle: '',
        type: 5,
      },
    ],
    validator: () => {
      return true;
    },
  },
  business: {
    addPoiType: 2,
    addPoiReason: '门店实际经营范围变更',
    footerBtnText: '提交资质',
    formConfig: [
      {
        title: '1.门头图',
        subTitle: '',
        type: 1,
      },
      {
        title: '2.新营业执照',
        subTitle: '',
        type: 2,
      },
      {
        title: '3.新经营类目证明',
        subTitle: '',
        type: 3,
      },
    ],
    validator: () => {
      return true;
    },
  },
  transfer: {
    addPoiType: 3,
    addPoiReason: '门店转让，老板变更',
    footerBtnText: '提交资质',
    formConfig: [
      {
        title: '1.门头图（必填提供）',
        subTitle: '',
        type: 1,
      },
      {
        title: '2.以下资质三选二（必填提供）',
        subTitle: '转让证明',
        type: 6,
      },
      {
        title: '',
        subTitle: '新房屋租赁合同',
        type: 7,
      },
      {
        title: '',
        subTitle: '新营业执照',
        type: 2,
      },
    ],
    validator: picInfos => {
      // 计算是否满足 三选二
      const count = [1, 2, 3].reduce(
        (prev, curr) => ((picInfos[curr] || []).length ? prev + 1 : prev),
        0
      ); // 若有图，则累加1
      return (picInfos[0] || []).length && count >= 2 ? true : false;
    },
  },
  status: {
    addPoiReason: '门店营业状态有误',
    footerBtnText: '重新开门',
    redirectToShopStatus: true,
  },
};
